import { render, staticRenderFns } from "./AudioButton.vue?vue&type=template&id=1e3451fd&scoped=true&"
import script from "./AudioButton.vue?vue&type=script&lang=js&"
export * from "./AudioButton.vue?vue&type=script&lang=js&"
import style0 from "./AudioButton.vue?vue&type=style&index=0&id=1e3451fd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3451fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
